/** Misma regla que portionGrams.util.js: la unidad sale del maestro de alimentos. */

function normalizeFoodUnit(unit) {
  return String(unit || 'g').toLowerCase().trim();
}

function isGramUnit(unit) {
  const u = normalizeFoodUnit(unit);
  return !u || u === 'g' || u === 'gr' || u === 'gramos' || u === 'gramo';
}

function isPieceUnit(unit) {
  const u = normalizeFoodUnit(unit);
  return u === 'unidad' || u === 'unidades' || u === 'und' || u === 'unid' || u === 'unid.';
}

function portionInputLabel(unit) {
  if (isPieceUnit(unit)) return 'unidades';
  if (isGramUnit(unit)) return 'g';
  return String(unit || 'g').trim() || 'g';
}

function defaultPortionQty(unit) {
  const u = normalizeFoodUnit(unit);
  if (isPieceUnit(unit) || (u && !isGramUnit(unit) && u !== 'ml')) return '1';
  return '100';
}

function formatQtyNumber(n) {
  const shown = Math.round(Number(n) * 100) / 100;
  if (!Number.isFinite(shown)) return '0';
  return String(shown);
}

function formatFoodQuantity(quantity, unit) {
  const n = Number(quantity);
  const q = Number.isFinite(n) ? n : 0;
  if (isGramUnit(unit)) return `${Math.round(q)}g`;
  const text = formatQtyNumber(q);
  if (isPieceUnit(unit)) return `${text} unid.`;
  const label = String(unit || '').trim();
  return label ? `${text} ${label}` : `${Math.round(q)}g`;
}

function round1(n) {
  return Math.round(Number(n) * 10) / 10;
}

/** Cantidad guardada en la unidad del maestro. Gramos viejos de un alimento por unidad pasan a unidades. */
function portionFromMaster(food, quantity) {
  const qty = Number(quantity);
  const unitRaw = food?.unit || 'g';
  const gpu = Number(food?.gramsPerUnit ?? food?.grams_per_unit);
  const piece = isPieceUnit(unitRaw);
  const grams = piece && gpu > 0
    ? (Number.isFinite(qty) && qty >= gpu ? qty : (Number.isFinite(qty) ? qty * gpu : 0))
    : (Number.isFinite(qty) ? qty : 0);
  const factor = grams / 100;
  const quantityStored = piece && gpu > 0 && grams > 0
    ? Math.round((grams / gpu) * 100) / 100
    : (Number.isFinite(qty) ? qty : grams);
  const per = (camel, snake) => Number(food?.[camel] ?? food?.[snake] ?? 0);
  return {
    unit: isGramUnit(unitRaw) ? 'g' : String(unitRaw).trim() || 'g',
    gramsPerUnit: gpu > 0 ? gpu : null,
    quantityGrams: quantityStored,
    calories: round1(per('caloriesPer100g', 'calories_per_100g') * factor),
    protein: round1(per('proteinPer100g', 'protein_per_100g') * factor),
    carbs: round1(per('carbsPer100g', 'carbs_per_100g') * factor),
    fat: round1(per('fatPer100g', 'fat_per_100g') * factor),
  };
}

function applyMasterToItem(item, food) {
  if (!food) return item;
  const qty = Number(item?.quantityGrams ?? item?.quantity_grams ?? item?.quantity ?? 0);
  const portion = portionFromMaster(food, qty);
  return {
    ...item,
    foodItemId: food.id || item?.foodItemId || item?.food_item_id,
    name: item?.name || food.name,
    unit: portion.unit,
    gramsPerUnit: portion.gramsPerUnit,
    quantityGrams: portion.quantityGrams,
    calories: portion.calories,
    protein: portion.protein,
    carbs: portion.carbs,
    fat: portion.fat,
  };
}

export {
  normalizeFoodUnit,
  isGramUnit,
  isPieceUnit,
  portionInputLabel,
  defaultPortionQty,
  formatFoodQuantity,
  portionFromMaster,
  applyMasterToItem,
};
